module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my_project"
  }, [_c('mt-header', {
    attrs: {
      "title": "我的工作"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/me')
      }
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my_type"
  }, [_c('router-link', {
    staticClass: "myRelease",
    class: {
      mypjtSelect: _vm.selected == 'myJob'
    },
    attrs: {
      "to": "/myJobs",
      "value": "myJob"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mypjtSelect()
      }
    }
  }, [(this.STATE.state.showReleaseTag > 0) ? _c('i', {
    staticClass: "red_icon"
  }) : _vm._e(), _vm._v("\n      我发布的\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "myJoin",
    class: {
      mypjtSelect: _vm.selected == 'myJoin'
    },
    attrs: {
      "to": "/myJobs/join",
      "value": "myJoin"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mypjtSelect()
      }
    }
  }, [_vm._v("\n      我参与的\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "myRecommend",
    class: {
      mypjtSelect: _vm.selected == 'myRecommend'
    },
    attrs: {
      "to": "/myJobs/recommend",
      "value": "myRecommend"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mypjtSelect()
      }
    }
  }, [(this.STATE.state.showRecommendTag > 0 && this.STATE.state.showRecommendTag < 99) ? _c('i', {
    staticClass: "red_icon hasNum"
  }, [_vm._v("+" + _vm._s(this.STATE.state.showRecommendTag))]) : _vm._e(), _vm._v(" "), (this.STATE.state.showRecommendTag >= 99) ? _c('i', {
    staticClass: "red_icon hasNum"
  }, [_vm._v("99+")]) : _vm._e(), _vm._v("\n      推荐给我\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "myApply",
    class: {
      mypjtSelect: _vm.selected == 'myApply'
    },
    attrs: {
      "to": "/myJobs/apply",
      "value": "myApply"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mypjtSelect()
      }
    }
  }, [_vm._v("\n      我申请的\n    ")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1564cfa4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/my_project.vue
// module id = 1262
// module chunks = 1